var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _default_1_editOperations, _default_1_currentItem, _default_1_saving, _default_1_itemAmountDisplayRoots;
import { expandFadeIn } from "@core/animations";
import { apiAxiosDefaults } from "@core/api";
import { throwIfExpiredLogin } from "@core/api/helpers";
import { ExpiredLoginError } from "@core/exceptions/exceptions";
import { handleExpiredLogin } from "@core/exceptions/handlers";
import { loading } from "@core/index";
import { CurrentFromMaxDisplayObserver, CurrentFromMaxDisplaySubject, rootWithComponent, } from "@core/react-components";
import { Controller } from "@hotwired/stimulus";
import axios, { AxiosError } from "axios";
import he from "he";
import { dispatchErrorOccurred, dispatchExpiredLoginErrorOccurred, dispatchUnexpectedErrorOccurred, } from "../../../events/erroroccurred";
import { dispatchErrorsCleared } from "../../../events/errorscleared";
var Visibility;
(function (Visibility) {
    Visibility[Visibility["Visible"] = 0] = "Visible";
    Visibility[Visibility["Invisible"] = 1] = "Invisible";
})(Visibility || (Visibility = {}));
const templateReplaceRegex = /(__id__|__companyId__|__attrContent__|__htmlContent__)/g;
function templateReplacerMap(id, companyId, attrContent, htmlContent) {
    return new Map([
        ["__id__", id.toString()],
        ["__companyId__", companyId],
        ["__attrContent__", attrContent],
        ["__htmlContent__", htmlContent],
    ]);
}
export default class default_1 extends Controller {
    constructor() {
        super(...arguments);
        // instance
        _default_1_editOperations.set(this, null);
        _default_1_currentItem.set(this, null);
        _default_1_saving.set(this, false);
        _default_1_itemAmountDisplayRoots.set(this, new WeakMap());
    }
    // private accesors to #editOperations just for utility
    get editOperations() {
        return __classPrivateFieldGet(this, _default_1_editOperations, "f");
    }
    set editOperations(v) {
        if (v) {
            this.cancelButtonTarget.classList.remove(this.hiddenClass);
        }
        else {
            this.cancelButtonTarget.classList.add(this.hiddenClass);
        }
        __classPrivateFieldSet(this, _default_1_editOperations, v, "f");
    }
    // stimulus callbacks
    initialize() {
        const axiosConfig = Object.assign({}, apiAxiosDefaults, {
            baseURL: this.baseUrlValue,
        });
        this.axios = axios.create(axiosConfig);
        this.itemAmountDisplaySubject = new CurrentFromMaxDisplaySubject();
    }
    itemAmountDisplayTargetConnected(target) {
        const root = rootWithComponent(target, CurrentFromMaxDisplayObserver, {
            atMaxClass: this.atMaxClasses.join(" "),
            initial: this.itemTargets.length,
            max: this.maxAmountItemsValue,
            subject: this.itemAmountDisplaySubject,
        });
        __classPrivateFieldGet(this, _default_1_itemAmountDisplayRoots, "f").set(target, root);
        this._updateCountDisplay();
    }
    itemAmountDisplayTargetDisconnected(target) {
        __classPrivateFieldGet(this, _default_1_itemAmountDisplayRoots, "f").get(target)?.unmount();
        __classPrivateFieldGet(this, _default_1_itemAmountDisplayRoots, "f").delete(target);
    }
    itemTargetConnected(target) {
        this._updateCountDisplay();
        this._changeSaveButtonVisibility();
        expandFadeIn(target, 350);
    }
    itemTargetDisconnected() {
        this._updateCountDisplay();
        this._changeSaveButtonVisibility();
    }
    saveButtonTargetConnected() {
        this._changeSaveButtonVisibility();
    }
    // handlers
    async saveItem() {
        dispatchErrorsCleared(this);
        if (!this.noteContentTarget.reportValidity()) {
            return;
        }
        // if no currentItem, it's prolly a new Item...
        const { id, companyId } = __classPrivateFieldGet(this, _default_1_currentItem, "f") || {
            id: 0,
            companyId: this.companyIdValue,
        };
        const content = this.noteContentTarget.value.trim();
        const itemData = {
            id,
            companyId,
            content,
        };
        if (!this._isUnique(itemData)) {
            this.noteContentTarget.setCustomValidity(this.notUniqueItemErrorValue);
            this.noteContentTarget.reportValidity();
            return;
        }
        const loadingFinished = loading(this.saveButtonTarget, "Grabando...");
        const cleanUp = this._prepareSave();
        if (this.editOperations) {
            try {
                await this._apiPostEditItem(itemData);
            }
            catch (error) {
                if (error instanceof
                    (AxiosError)) {
                    if (error.response) {
                        // @todo
                    }
                    else if (error.request) {
                        // @todo
                    }
                }
                else if (error instanceof ExpiredLoginError) {
                    this._handleExpiredLogin(error);
                }
                else {
                    dispatchErrorOccurred(this, error, "Se presentó un problema al intentar guardar la nota. Por favor," +
                        " intente nuevamente, ó contacte a soporte.");
                }
                cleanUp(false);
                return;
            }
            finally {
                loadingFinished();
            }
            this.editOperations.commit(itemData);
            this.editOperations = null;
        }
        else {
            const itemTemplate = document.getElementById(this.itemTemplateIdValue);
            if (!itemTemplate) {
                this._handleUnexpectedError(new Error(`Item template not found. ID: "${this.itemTemplateIdValue}"`));
                loadingFinished();
                cleanUp(false);
                return;
            }
            const templateHtml = itemTemplate.innerHTML.trim();
            if (!templateHtml) {
                this._handleUnexpectedError(new Error("Item template is empty."));
                loadingFinished();
                cleanUp(false);
                return;
            }
            try {
                await this._apiPostNewItem(itemData);
            }
            catch (error) {
                if (error instanceof (AxiosError)) {
                    if (error.response) {
                        // @todo
                    }
                    else if (error.request) {
                        // @todo
                    }
                }
                else if (error instanceof ExpiredLoginError) {
                    this._handleExpiredLogin(error);
                }
                else {
                    this._handleUnexpectedError(error);
                }
                cleanUp(false);
                return;
            }
            finally {
                loadingFinished();
            }
            const newItem = document.createElement("template");
            const escapedContent = he.encode(itemData.content);
            const replaceMap = templateReplacerMap(itemData.id, itemData.companyId, escapedContent, escapedContent);
            newItem.innerHTML = templateHtml.replace(templateReplaceRegex, (m) => replaceMap.get(m) || m);
            this.itemsContainerTarget.appendChild(newItem.content.firstChild);
        }
        cleanUp(true);
    }
    beginEdit(editEvent) {
        dispatchErrorsCleared(this);
        const detail = editEvent.detail;
        if (__classPrivateFieldGet(this, _default_1_saving, "f")) {
            detail.cancel();
            return;
        }
        if (this.editOperations) {
            this.editOperations.cancel();
        }
        this.editOperations = {
            commit: detail.commit,
            cancel: detail.cancel,
        };
        __classPrivateFieldSet(this, _default_1_currentItem, detail.item, "f");
        this._setNoteContent(detail.item.content.trim());
        this._changeSaveButtonVisibility(Visibility.Visible);
    }
    cancelEdit() {
        dispatchErrorsCleared(this);
        if (this.editOperations) {
            this.editOperations.cancel();
            this.editOperations = null;
        }
        __classPrivateFieldSet(this, _default_1_currentItem, null, "f");
        this._setNoteContent("");
        this._changeSaveButtonVisibility();
    }
    removeItem(removeEvent) {
        const detail = removeEvent.detail;
        const itemId = detail.item.id;
        // validate item removal?
        // if fails: removeEvent.preventDefault();
    }
    // internals
    _updateCountDisplay() {
        this.itemAmountDisplaySubject.notify(this.itemTargets.length);
    }
    // could be repurposed as a stimulus value to have access to it's change callback...
    _setNoteContent(content) {
        this.noteContentTarget.value = content;
        this.noteContentTarget.dispatchEvent(new InputEvent("input"));
    }
    _prepareSave() {
        __classPrivateFieldSet(this, _default_1_saving, true, "f");
        this.saveButtonTarget.disabled = true;
        this.cancelButtonTarget.disabled = true;
        return (clear) => {
            __classPrivateFieldSet(this, _default_1_saving, false, "f");
            this.saveButtonTarget.disabled = false;
            this.cancelButtonTarget.disabled = false;
            if (clear) {
                __classPrivateFieldSet(this, _default_1_currentItem, null, "f");
                this._setNoteContent("");
            }
            this._changeSaveButtonVisibility();
        };
    }
    _isAtMaxItems() {
        return this.itemTargets.length >= this.maxAmountItemsValue;
    }
    _changeSaveButtonVisibility(visibility) {
        if (!this.hasSaveButtonTarget) {
            return;
        }
        // kinda weird to do this
        if (visibility === undefined) {
            visibility = this._isAtMaxItems()
                ? Visibility.Invisible
                : Visibility.Visible;
        }
        if (visibility === Visibility.Visible) {
            this.saveButtonTarget.classList.remove(this.hiddenClass);
        }
        else {
            this.saveButtonTarget.classList.add(this.hiddenClass);
        }
    }
    _isUnique(item) {
        for (const itemTarget of this.itemTargets) {
            const event = this.dispatch("isunique", {
                target: itemTarget,
                bubbles: false,
                cancelable: true,
                detail: item,
            });
            if (event.defaultPrevented) {
                return false;
            }
        }
        return true;
    }
    async _apiPostNewItem(itemData) {
        const response = await this.axios.post(this.newNoteUrlValue, itemData);
        const parsedData = this._parseResponse(response);
        return Object.assign(itemData, parsedData);
    }
    async _apiPostEditItem(itemData) {
        const response = await this.axios.post(this.updateNoteUrlValue, itemData);
        const parsedData = this._parseResponse(response);
        return Object.assign(itemData, parsedData);
    }
    _parseResponse(response) {
        const parsedData = this._parseApiResponse(response.data);
        if (parsedData) {
            // golden
            return parsedData;
        }
        if (response.request) {
            // request is xhr on browser
            const xhr = response.request;
            // check if we got redirected to login
            const dummyA = document.createElement("a");
            dummyA.href = this.axios.getUri(response.config);
            const requestUrl = new URL(dummyA.href);
            const responseUrl = new URL(xhr.responseURL);
            throwIfExpiredLogin(requestUrl, responseUrl);
        }
        this._handleUnexpectedError(new Error("Malformed response body"));
    }
    _parseApiResponse(response) {
        if (response.data &&
            "id" in response.data &&
            "companyId" in response.data &&
            "content" in response.data) {
            return {
                id: response.data.id,
                companyId: response.data.companyId,
                content: response.data.content,
            };
        }
        return null;
    }
    _handleExpiredLogin(error) {
        dispatchExpiredLoginErrorOccurred(this, error);
        handleExpiredLogin(error);
    }
    _handleUnexpectedError(error) {
        dispatchUnexpectedErrorOccurred(this, error);
    }
}
_default_1_editOperations = new WeakMap(), _default_1_currentItem = new WeakMap(), _default_1_saving = new WeakMap(), _default_1_itemAmountDisplayRoots = new WeakMap();
default_1.values = {
    maxAmountItems: { type: Number, default: 4 },
    notUniqueItemError: String,
    itemTemplateId: String,
    baseUrl: String,
    newNoteUrl: String,
    updateNoteUrl: String,
    companyId: String,
};
default_1.targets = [
    "itemAmountDisplay",
    "noteContent",
    "saveButton",
    "item",
    "itemsContainer",
    "cancelButton",
];
default_1.classes = ["hidden", "atMax"];
//# sourceMappingURL=main_controller.js.map